<template>
    <div class="download-area">
        <div class="download-bg"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-title text-center">
                        <h1 class="text-white">Alguns <span>Parceiros</span></h1>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="partner-item col-md-3">
                    <img src = "/img/site/banners/betel_tecnologia.png" alt = "Betel Tecnologia" />
                </div>
                <div class="partner-item col-md-3">
                    <img src = "/img/site/banners/caixa.png" alt = "Caixa Econômica Federal" />
                </div>
                <div class="partner-item col-md-3">
                    <img src = "/img/site/banners/cielo.png" alt = "Cielo" />
                </div>
                <div class="partner-item col-md-3">
                    <img src = "/img/site/banners/amazon.png" alt = "Amazon" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>